import { decision } from './decision'
import { EngineResult } from './constants'

import { evaluateDaily } from './evaluateDaily'
import { evaluateWeekly } from './evaluateWeekly'
import { evaluateMonthly } from './evaluateMonthly'
import { evaluateYearly } from './evaluateYearly'
import { evaluateOncePerSeason } from './evaluateOncePerSeason'


// ============================================================
// EVALUATE SCHEDULE
// ============================================================
//
// Supported recurrence schedules:
//
//   Daily
//   Weekly
//   Monthly
//   Yearly
//
// Once-per-Season is represented by:
//
//   recurrence_type_id = NULL
//   season_id = assigned Season
//
// A Season is a calendar window/container.
// It is NOT itself a recurrence cadence.
//
// ============================================================

export function evaluateSchedule({
  template,
  operationalDate,
  existingTasks = []
}) {

  // ==========================================================
  // ONCE PER SEASON
  // ==========================================================
  //
  // Once has no recurrence_type_id.
  //
  // The presence of season_id tells us that NULL means
  // "Once per Season" rather than an incomplete template.
  //
  // ==========================================================

  if (
    template.recurrence_type_id == null &&
    template.season_id
  ) {

    return evaluateOncePerSeason({
      template,
      existingTasks,
      operationalDate
    })
  }


  // ==========================================================
  // NORMAL RECURRENCE TYPES
  // ==========================================================

  switch (
    Number(template.recurrence_type_id)
  ) {

    case 1:
      return evaluateDaily({
        template,
        operationalDate
      })

    case 2:
      return evaluateWeekly({
        template,
        operationalDate
      })

    case 3:
      return evaluateMonthly({
        template,
        operationalDate
      })

    case 4:
      return evaluateYearly({
        template,
        operationalDate
      })

    // --------------------------------------------------------
    // Legacy Seasonal records
    //
    // Existing type 5 records are intentionally not migrated
    // yet. Seasonal is no longer a cadence.
    // --------------------------------------------------------

    case 5:
      return decision({
        generate: false,
        code: EngineResult.NOT_IMPLEMENTED,
        reason:
          'Seasonal is a calendar window, not a recurrence schedule'
      })

    // --------------------------------------------------------
    // Legacy Interval records
    // --------------------------------------------------------

    case 6:
      return decision({
        generate: false,
        code: EngineResult.NOT_IMPLEMENTED,
        reason:
          'Interval is not a supported recurrence type'
      })

    default:
      return decision({
        generate: false,
        code: EngineResult.UNKNOWN_TYPE,
        reason:
          'Unknown type or recurrence configuration'
      })
  }
}